<template>
  <div class="container-filtro-relatorio" @click="toogleActive">
    <SvgIcon iconName="icon-file-lines-solid" class="fill-maino-green" />
    <div class="container-options" v-if="filterActive">
      <div class="subcontainer-options">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="option"
          @click="atualizar(option.id)"
        >
          {{ option.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from '../../../../shared/SvgIcon.vue';
import { normalizarParamsMultiselect } from '../../helpers/index';
export default {
  name: 'Multiple',
  data() {
    return {
      options: [
        { id: 'pdf', name: 'Exportar em PDF' },
        { id: 'xlsx', name: 'Exportar em Excel' },
      ],
      filterActive: false,
      selecionado: 'pdf',
      filtro: "format",
      path: window.location.pathname,
    }
  },
  components: {
    SvgIcon
  },
  methods: {
    atualizar(id) {
      this.selecionado = id;
      const paramsNormalizados = normalizarParamsMultiselect(new URLSearchParams(window.location.search));
      if (id === 'pdf') {
        window.open(
          `${this.path}?${paramsNormalizados.toString()}&format=pdf`,
          '_blank',
          'noopener,noreferrer'
        );
      } else {
        window.history.replaceState({}, '', `${this.path}?${paramsNormalizados.toString()}`);
        this.$aplicaFiltroEmURL(this.filtro, id, this.path);
        this.$store.commit('addFiltro', this.filtro);
        window.location.reload();
      }
    },
    toogleActive() {
      this.filterActive = !this.filterActive;
    },
  },
  mounted() {
    document.addEventListener('click', (event) => {
      const el = this.$el;
      if (this.filterActive && el && !el.contains(event.target)) {
        this.filterActive = false;
      }
    });
  },
}
</script>
